import { Box, Flex, Heading, Text } from "@theme-ui/components";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import styled from "@emotion/styled";
import { getCommonData } from "../../../../../packages/shared-utils/src/components/utils/regionContent";
import { StarRating } from "../atoms";
import { colors, typography } from "../../styles/theme";

const G2Reviews = ({ backgroundColor, regionCode, g2Badges }) => {
  if (!g2Badges) {
    return null;
  }

  const { g2Badge1, g2Badge2, g2Badge3, g2Badge4, g2Badge5, g2Badge6 } =
    g2Badges;

  const g2Banners = [
    g2Badge1,
    g2Badge2,
    g2Badge3,
    g2Badge4,
    g2Badge5,
    g2Badge6,
  ].filter(Boolean);

  const g2Heading = getCommonData(regionCode)?.g2Heading;

  if (g2Banners.length === 0) {
    return null;
  }

  return (
    <Flex
      sx={{
        ...styles.container,
        backgroundColor: backgroundColor ? backgroundColor : null,
      }}
    >
      <Flex sx={styles.heading}>
        <Heading as="h2" sx={typography.h2}>
          {g2Heading}
        </Heading>
        <StarRating rating={4.4} fontSize={"1.125rem"} />
      </Flex>
      <Flex sx={styles.flex}>
        {g2Banners.map((banner, i) => (
          <Box
            key={"banner-" + i}
            sx={{ maxWidth: ["8.25rem", "8.25rem", "6.375rem", "8.25rem"] }}
          >
            <StyledImage
              image={getImage(banner)}
              alt={`G2crowd Badge ${i + 1}`}
              imgStyle={{ objectFit: "contain" }}
            />
          </Box>
        ))}
      </Flex>
    </Flex>
  );
};

const styles = {
  flex: {
    flexWrap: "wrap",
    justifyContent: "center",
    alignItems: "center",
    gap: ["3rem", "3rem", "1.5rem", "3rem"],
    maxWidth: "95%",
    mx: "auto",
  },
  container: {
    py: ["4rem", "4rem", "7rem", "7rem"],
    bg: colors.secondaryOrange100,
    width: "100%",
    gap: ["2rem", "2rem", "2rem", "4rem"],
    flexDirection: "column",
  },
  heading: {
    ...typography.h2,
    display: "flex",
    flexDirection: ["column", "column", "column", "column"],
    justifyContent: "center",
    alignItems: "center",
    gap: "1rem",
  },
};

const StyledImage = styled(GatsbyImage)`
  height: 9.188rem;
  @media (max-width: 899px) and (min-width: 600px) {
    height: 7.063rem;
  }
`;

export default G2Reviews;
